import { SettingsRadioItem } from 'modules/settingsContainer/SettingsRadio/types';
import { OrientationType } from 'store/reducers/visualisations/types';

export const orientationOptions: SettingsRadioItem<OrientationType>[] = [
  { value: 'horizontal', label: 'Горизонтально' },
  { value: 'vertical', label: 'Вертикально' },
];
